import { z } from 'zod';

/* GET /api/admin/metrics?range=7d|30d */
export const MetricsRangeSchema = z.enum(['7d', '30d']);
export type MetricsRange = z.infer<typeof MetricsRangeSchema>;

/** One calendar day. `date` is `YYYY-MM-DD`. */
export const MetricPointSchema = z.object({
  date: z.string(),
  signups: z.number().int().nonnegative(),
  reportsOpened: z.number().int().nonnegative(),
  sanctions: z.number().int().nonnegative(),
});
export type MetricPoint = z.infer<typeof MetricPointSchema>;

export const MetricsResponseSchema = z.object({
  range: MetricsRangeSchema,
  points: z.array(MetricPointSchema),
  totals: z.object({
    signups: z.number().int().nonnegative(),
    reportsOpened: z.number().int().nonnegative(),
    sanctions: z.number().int().nonnegative(),
  }),
});
export type MetricsResponse = z.infer<typeof MetricsResponseSchema>;
